/**
 * @generated SignedSource<<c7fca38e81e6c872916a3e9d0c830701>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePreloadedDuties_deliveryOptions$data = ReadonlyArray<{
  readonly isLocalPickup: boolean | null;
  readonly serviceId: string | null;
  readonly showQuoteAsPending: boolean | null;
  readonly " $fragmentType": "usePreloadedDuties_deliveryOptions";
}>;
export type usePreloadedDuties_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: usePreloadedDuties_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePreloadedDuties_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "usePreloadedDuties_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocalPickup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "9efa0fd7084f8061b5e8e8439082803a";

export default node;
